import type { RouteObject } from 'react-router-dom'
import { RouteRoleGuard } from '../features/auth/components/RouteRoleGuard'
import type { RoleType } from '../features/auth/auth.types'

/**
 * Route handle type with optional roles
 */
export interface RouteHandle {
  title?: string
  roles?: RoleType[]
}

/**
 * Processes routes and automatically wraps elements with RouteRoleGuard
 * when handle.roles is present
 */
export function processRoutes(routes: RouteObject[]): RouteObject[] {
  return routes.map(route => {
    const handle = route.handle as RouteHandle | undefined
    const hasRoles = handle?.roles && handle.roles.length > 0

    // If route has roles in handle, wrap element with RouteRoleGuard
    if (hasRoles && route.element) {
      const processedRoute: RouteObject = {
        ...route,
        element: (
          <RouteRoleGuard>
            {route.element}
          </RouteRoleGuard>
        ),
      }
      
      // Recursively process children if they exist
      if (route.children) {
        processedRoute.children = processRoutes(route.children)
      }
      
      return processedRoute
    }

    // If no roles, just process children recursively
    if (route.children) {
      return {
        ...route,
        children: processRoutes(route.children),
      }
    }

    return route
  })
}

